import React from 'react';
import dayjs from 'dayjs';

import CourseCardVerticalWithProgress from './CourseCardVerticalWithProgress';
import CourseCardVerticalWithExpiry from './CourseCardVerticalWithExpiry';
import CourseCardHorizontalWithProgress from './CourseCardHorizontalWithProgress';
import CourseCardHorizontalWithExpiry from './CourseCardHorizontalWithExpiry';

export const CARD_TYPES = {
  DEFAULT: 'DEFAULT',
  SMALL: 'SMALL',
};

export const BADGE_VARIANTS = {
  EBOOK: 'EBOOK',
  LEARNING_MODE: 'LEARNING_MODE',
  NONE: 'NONE',
};

export const CLASSROOM_TIME_TYPE = {
  LIMITED: 'LIMITED',
  UNLIMITED: 'UNLIMITED',
};

export const MODAL_TYPE = {
  EXPIRY_MODAL: 'EXPIRY_MODAL',
  REMAINING_TIMEOUT: 'REMAINING_TIMEOUT',
};

const isLockedCourse = (expDate, isValidRemainingTime) => {
  return (
    (isValidRemainingTime !== undefined && !isValidRemainingTime) ||
    (expDate && dayjs(expDate).isBefore(dayjs()))
  );
};

const getModalType = (expDate, isValidRemainingTime) => {
  if (expDate && dayjs(expDate).isBefore(dayjs())) {
    return MODAL_TYPE.EXPIRY_MODAL;
  }
  if (isValidRemainingTime !== undefined && !isValidRemainingTime) {
    return MODAL_TYPE.REMAINING_TIMEOUT;
  }
};

const isShowRemainingTime = (time, timeType) => timeType !== CLASSROOM_TIME_TYPE.UNLIMITED && time;

const CourseCard = ({
  CourseCardVariant,
  imageUrl,
  defaultImageUrl,
  title,
  time,
  timeType,
  isValidRemainingTime,
  expDate,
  onClick,
  progress,
  name,
  totalActiveLearningModes,
  ...props
}) => {
  const isLocked = isLockedCourse(expDate, isValidRemainingTime);
  const modalType = getModalType(expDate, isValidRemainingTime);
  const showRemainingTime = isShowRemainingTime(time, timeType);
  switch (CourseCardVariant) {
    case 'VerticalWithProgress': {
      return (
        <CourseCardVerticalWithProgress
          imageUrl={imageUrl}
          defaultImageUrl={defaultImageUrl}
          title={title}
          onClick={onClick}
          progress={progress}
          name={`${name}-vertical-with-progress`}
          {...props}
        />
      );
    }
    case 'VerticalWithProgress_SMALL': {
      return (
        <CourseCardVerticalWithProgress
          variant={CARD_TYPES.SMALL}
          imageUrl={imageUrl}
          defaultImageUrl={defaultImageUrl}
          title={title}
          onClick={onClick}
          progress={progress}
          name={`${name}-vertical-with-progress-small`}
          {...props}
        />
      );
    }
    case 'HorizontalWithProgress': {
      return (
        <CourseCardHorizontalWithProgress
          imageUrl={imageUrl}
          defaultImageUrl={defaultImageUrl}
          title={title}
          onClick={onClick}
          progress={progress}
          name={`${name}-horizontal-with-progress`}
          {...props}
        />
      );
    }
    case 'HorizontalWithExpiry': {
      return (
        <CourseCardHorizontalWithExpiry
          imageUrl={imageUrl}
          defaultImageUrl={defaultImageUrl}
          title={title}
          onClick={onClick}
          progress={progress}
          time={time}
          expDate={expDate}
          isLockedCourse={isLocked}
          modalType={modalType}
          isShowRemainingTime={showRemainingTime}
          name={`${name}-horizontal-with-expiry`}
          totalActiveLearningModes={totalActiveLearningModes}
          {...props}
        />
      );
    }
    case 'VerticalWithExpiry_SMALL': {
      return (
        <CourseCardVerticalWithExpiry
          variant={CARD_TYPES.SMALL}
          imageUrl={imageUrl}
          defaultImageUrl={defaultImageUrl}
          title={title}
          onClick={onClick}
          progress={progress}
          time={time}
          expDate={expDate}
          isLockedCourse={isLocked}
          modalType={modalType}
          isShowRemainingTime={showRemainingTime}
          name={`${name}-vertical-with-expiry-small`}
          totalActiveLearningModes={totalActiveLearningModes}
          {...props}
        />
      );
    }
    case 'VerticalWithExpiry':
    default: {
      return (
        <CourseCardVerticalWithExpiry
          imageUrl={imageUrl}
          defaultImageUrl={defaultImageUrl}
          title={title}
          onClick={onClick}
          progress={progress}
          time={time}
          expDate={expDate}
          isLockedCourse={isLocked}
          modalType={modalType}
          isShowRemainingTime={showRemainingTime}
          name={`${name}-vertical-with-expiry`}
          totalActiveLearningModes={totalActiveLearningModes}
          {...props}
        />
      );
    }
  }
};

export default CourseCard;
